import { UnitValue } from '../../data-structures/unit-value.model';
import {v4 as uuid} from 'uuid';

export interface BiogasShareInterface {
  name: string;
  share: UnitValue;
  uuid: string | null;
}

export class BiogasShare {
  public name: string;
  public share: UnitValue;
  public uuid: string | null;

  constructor(param: BiogasShareInterface = {
    name: '',
    share: new UnitValue(),
    uuid: null
  }) {
    this.name = param.name;
    this.share = new UnitValue(param.share);
    this.uuid = param.uuid ? param.uuid : uuid();
  }
}

export enum BiogasSharePropName {
  share= 'INPUT_SUMMARY.PLANT_SPECIFICATIONS.BIOGAS_SHARE.SHARE'
}
